import CommonService from '../../../services/common-api-service';

export default class UserManagementPageApis {
    cs;
    constructor() {
        this.cs = new CommonService();
    }

    createUserLogin = loginInfo => this.cs.httpConnection(`/UserManagement/CreateUser`, 'postNoAPIUrl', loginInfo);

    deleteUserAccount = userInfo => this.cs.httpConnection(`/UserManagement/DeleteUser`,'deleteNoAPIUrl', userInfo);

    getRoles = () => this.cs.httpConnection('/Role/GetRoles', 'getNoAPIUrl');

    assignRole = (userInfo) => this.cs.httpConnection('/Role/AssignRole', 'postNoAPIUrl', userInfo);

    deleteRole = (userInfo) => this.cs.httpConnection('/Role/RemoveRole', 'postNoAPIUrl', userInfo);

    createUserProfile = (userProfile) => this.cs.httpConnection('/UserProfile/CreateUserProfile', "post", userProfile);

    createUserPreference = (userPreference) => this.cs.httpConnection('/UserPreferences/CreateUserPreference', "post", userPreference);
    
    getUserList = () => this.cs.httpConnection('/UserProfile/GetAllUsers','get');

    getGrandparentAccountList = () => this.cs.httpConnection('/GrandParentAccount/GetAll','get');

    createGrandparentAccount = (grandparentAccount) => this.cs.httpConnection('/GrandParentAccount/Create','post', grandparentAccount);

    assignGrandparentAccount = (assignInfo) => this.cs.httpConnection('/UserProfile/AssignGrandParentAccount','put', assignInfo);

    updateGrandparentAccountParentAccount = (assignInfo) => this.cs.httpConnection('ParentAccount/UpdateGrandParentAccount','post', assignInfo);
}